module.exports = {
  ADDRESSCLOUD_ENV: process.env.REACT_APP_ADDRESSCLOUD_ENV,
  AUTH0_AUDIENCE: process.env.REACT_APP_AUTH0_AUDIENCE,
  AUTH0_CALLBACK_URL: process.env.REACT_APP_AUTH0_CALLBACK_URL,
  AUTH0_CLIENT_ID: process.env.REACT_APP_AUTH0_CLIENT_ID,
  AUTH0_DOMAIN: process.env.REACT_APP_AUTH0_DOMAIN,
  AUTH0_NAMESPACE: process.env.REACT_APP_AUTH0_NAMESPACE,
  COUNTRIES: (process.env.REACT_APP_COUNTRIES || 'gb,im,je,gg,ie').split(','),
  CRS: [4326, 4269, 27700, 29902, 3857, 900913],
  DEBUG: process.env.REACT_APP_DEBUG === 'true' || false,
  FUZZY: [0,1,2],
  GA_ID: process.env.REACT_APP_GA_ID,
  GEO_ACCURACIES: 'rooftop,interpolated,grid,postcode1,building_group,street,postcode2,locality,postcode3,subregion,postcode4,region'.split(','),
  LANGUAGES: 'auto,en,ga,cy'.split(','),
  LOCATION_TYPES: 'address,postcode1,building_group,street,postcode2,locality,postcode3,subregion,postcode4,region'.split(','),
  MAPBOX_KEY: process.env.REACT_APP_MAPBOX_KEY,
  MULTIMATCH: 'all,none,best,first,picklist'.split(','),
  POSTCODE_MATCH: 'exact,auto,fuzzy'.split(','),
  VERSION: process.env.REACT_APP_VERSION,
}
